var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "card_x2C__credit_x2C__Mastercard_x2C___bank_x2C__debit_x2C_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M495.998,389.952c0,8.835-7.215,16.051-16.051,16.051H32.053    c-8.836,0-16.051-7.216-16.051-16.051V122.049c0-8.836,7.215-16.052,16.051-16.052h447.895c8.836,0,16.051,7.216,16.051,16.052    V389.952z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#14477C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.576,342.069 317.994,341.983 322.418,341.712     326.743,341.077 330.982,340.356 335.13,339.364 339.277,338.286 343.244,336.839 347.213,335.311 350.996,333.591 354.693,331.7     358.304,329.623 361.822,327.374 365.248,324.94 368.495,322.414 371.558,319.709 374.619,316.819 377.418,313.843     380.129,310.688 382.74,307.44 385.174,304.108 387.338,300.589 389.506,296.985 391.306,293.288 393.111,289.412 394.645,285.53     396,281.476 397.172,277.415 398.158,273.269 398.885,268.937 399.427,264.703 399.783,260.279 399.871,255.867 399.783,251.443     399.427,247.025 398.885,242.786 398.158,238.554 397.172,234.4 396,230.347 394.645,226.285 393.111,222.41 391.306,218.62     389.506,214.924 387.338,211.318 385.174,207.801 382.74,204.467 380.129,201.22 377.418,198.065 374.619,195.089     371.558,192.292 368.495,189.587 365.248,186.975 361.822,184.627 358.304,182.371 354.693,180.301 350.996,178.403     347.213,176.69 343.244,175.162 339.277,173.807 335.13,172.636 330.982,171.644 326.743,170.923 322.418,170.381     317.994,170.018 313.576,169.931 309.158,170.018 304.833,170.381 300.501,170.923 296.268,171.644 292.115,172.636     287.969,173.807 283.996,175.162 280.121,176.69 276.332,178.403 272.635,180.301 269.031,182.371 265.512,184.627     262.179,186.975 258.925,189.587 255.771,192.292 252.801,195.089 249.91,198.065 247.299,201.22 244.68,204.467 242.338,207.801     240.083,211.318 238.013,214.924 236.115,218.62 234.402,222.41 232.867,226.285 231.519,230.347 230.348,234.4 229.35,238.554     228.635,242.786 228.092,247.025 227.729,251.443 227.637,255.867 227.729,260.279 228.092,264.703 228.635,268.937     229.35,273.269 230.348,277.415 231.519,281.476 232.867,285.53 234.402,289.412 236.115,293.288 238.013,296.985     240.083,300.589 242.338,304.108 244.68,307.44 247.299,310.688 249.91,313.843 252.801,316.819 255.771,319.709 258.925,322.414     262.179,324.94 265.512,327.374 269.031,329.623 272.635,331.7 276.332,333.591 280.121,335.311 283.996,336.839 287.969,338.286     292.115,339.364 296.268,340.356 300.501,341.077 304.833,341.712 309.158,341.983 313.576,342.069   ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBB230"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.424,342.069 202.842,341.983 207.167,341.712     211.499,341.077 215.732,340.356 219.885,339.364 224.037,338.286 228,336.839 231.875,335.311 235.666,333.591 239.361,331.7     242.967,329.623 246.484,327.374 249.818,324.94 253.072,322.414 256.227,319.709 259.196,316.819 262.087,313.843     264.705,310.688 267.318,307.44 269.659,304.108 271.914,300.589 273.984,296.985 275.883,293.288 277.596,289.412 279.13,285.53     280.479,281.476 281.655,277.415 282.648,273.269 283.363,268.937 283.904,264.703 284.269,260.279 284.36,255.867     284.269,251.443 283.904,247.025 283.363,242.786 282.648,238.554 281.655,234.4 280.479,230.347 279.13,226.285 277.596,222.41     275.883,218.62 273.984,214.924 271.914,211.318 269.659,207.801 267.318,204.467 264.705,201.22 262.087,198.065     259.196,195.089 256.227,192.292 253.072,189.587 249.818,186.975 246.484,184.627 242.967,182.371 239.361,180.301     235.666,178.403 231.875,176.69 228,175.162 224.037,173.807 219.885,172.636 215.732,171.644 211.499,170.923 207.167,170.381     202.842,170.018 198.424,169.931 194.006,170.018 189.582,170.381 185.256,170.923 181.018,171.644 176.877,172.636     172.724,173.807 168.756,175.162 164.787,176.69 161.004,178.403 157.308,180.301 153.696,182.371 150.185,184.627     146.758,186.975 143.506,189.587 140.443,192.292 137.38,195.089 134.583,198.065 131.871,201.22 129.26,204.467 126.826,207.801     124.662,211.318 122.494,214.924 120.694,218.62 118.889,222.41 117.355,226.285 116.006,230.347 114.828,234.4 113.93,238.554     113.115,242.786 112.58,247.025 112.216,251.443 112.13,255.867 112.216,260.279 112.58,264.703 113.115,268.937 113.93,273.269     114.828,277.415 116.006,281.476 117.355,285.53 118.889,289.412 120.694,293.288 122.494,296.985 124.662,300.589     126.826,304.108 129.26,307.44 131.871,310.688 134.583,313.843 137.38,316.819 140.443,319.709 143.506,322.414 146.758,324.94     150.185,327.374 153.696,329.623 157.308,331.7 161.004,333.591 164.787,335.311 168.756,336.839 172.724,338.286     176.877,339.364 181.018,340.356 185.256,341.077 189.582,341.712 194.006,341.983 198.424,342.069   ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EB2230"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.943,202.933 291.666,202.933 291.666,198.243     249.91,198.243 245.943,202.933   ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBB230"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.091,213.303 291.666,213.303 291.666,208.613     241.796,208.613 239.091,213.303   ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBB230"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.952,223.673 291.666,223.673 291.666,218.983     236.028,218.983 233.952,223.673   ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBB230"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.434,234.043 291.666,234.043 291.666,229.446     231.875,229.446 230.434,234.043   ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBB230"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.504,284.359 291.844,284.359 291.844,279.671     231.068,279.671 232.504,284.359   ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBB230"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.836,294.729 291.844,294.729 291.844,290.04     234.673,290.04 236.836,294.729   ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBB230"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.059,305.1 291.844,305.1 291.844,300.411     240.083,300.411 243.059,305.1   ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBB230"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.537,315.47 291.844,315.47 291.844,310.78     247.391,310.78 251.537,315.47   ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBB230"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.363,244.413 291.666,244.413 291.666,239.811     229.264,239.811 228.363,244.413   ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBB230"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.954,273.989 291.123,273.989 291.123,269.3     267.859,269.3 266.954,273.989   ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBB230"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.846,263.619 291.123,263.619 291.123,258.93     269.752,258.93 268.846,263.619   ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBB230"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.736,258.93 233.047,258.93 233.047,263.619     227.101,263.619 226.736,258.93   ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBB230"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.576,304.379c2.256,0,4.061,1.892,4.061,4.054    c0,2.256-1.805,4.061-4.061,4.061c-2.255,0-4.054-1.805-4.054-4.061C387.522,306.271,389.321,304.379,391.576,304.379    L391.576,304.379z M391.576,305.1c1.898,0,3.426,1.534,3.426,3.333c0,1.898-1.527,3.432-3.426,3.432    c-1.799,0-3.34-1.533-3.34-3.432C388.236,306.634,389.777,305.1,391.576,305.1L391.576,305.1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBB230"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.049,310.238v-3.426h1.441c0.357,0,0.629,0,0.813,0.093c0.173,0.086,0.271,0.178,0.357,0.265    c0.087,0.185,0.179,0.364,0.179,0.542c0,0.271-0.092,0.542-0.179,0.635c-0.185,0.179-0.45,0.271-0.728,0.357    c0.186,0.093,0.277,0.185,0.37,0.271c0.086,0.092,0.271,0.271,0.357,0.542l0.45,0.721h-0.808l-0.548-0.813    c-0.094-0.271-0.266-0.357-0.357-0.449c0-0.087-0.093-0.087-0.18-0.179c-0.092,0-0.184,0-0.363,0h-0.092v1.441H390.049z     M390.764,308.254h0.455c0.357,0,0.537,0,0.629-0.086c0.086,0,0.186,0,0.186-0.093c0.086-0.092,0.086-0.178,0.086-0.271    s0-0.179-0.086-0.271c-0.1-0.094-0.186-0.094-0.277-0.18c0,0-0.18,0-0.45,0h-0.542V308.254z",
    style: {
      fill: "#FBB230"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.677,270.472c2.255,0,4.055,1.805,4.055,4.061    c0,2.255-1.8,4.054-4.055,4.054s-4.054-1.799-4.054-4.054C386.623,272.276,388.422,270.472,390.677,270.472L390.677,270.472z     M390.677,271.192c1.898,0,3.427,1.533,3.427,3.34c0,1.891-1.528,3.426-3.427,3.426c-1.897,0-3.426-1.535-3.426-3.426    C387.251,272.726,388.779,271.192,390.677,271.192L390.677,271.192z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.143,276.245v-3.34h1.442c0.362,0,0.634,0,0.813,0.092c0.092,0,0.264,0.18,0.357,0.271    c0.092,0.179,0.178,0.357,0.178,0.543c0,0.271-0.086,0.449-0.271,0.627c-0.086,0.18-0.356,0.271-0.627,0.364    c0.092,0.086,0.271,0.179,0.363,0.271c0.092,0.086,0.178,0.266,0.357,0.537l0.455,0.635h-0.813l-0.543-0.722    c-0.179-0.271-0.271-0.45-0.363-0.45c-0.086-0.092-0.086-0.185-0.173-0.185c-0.099,0-0.185,0-0.363,0h-0.179v1.356H389.143z     M389.777,274.353h0.542c0.357,0,0.536,0,0.628-0.092c0.088,0,0.18-0.093,0.18-0.093c0.092-0.086,0.092-0.179,0.092-0.271    c0-0.086-0.092-0.271-0.092-0.271c-0.092-0.086-0.18-0.179-0.271-0.179s-0.271,0-0.536,0h-0.542V274.353z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.695,276.873l5.859-30.654h7.303l0.905,3.154    c1.35-1.355,3.604-3.154,8.114-3.154l-2.254,8.115c-1.984,0-5.053-0.363-7.572,5.588c-1.893,4.511-2.798,11.991-3.791,16.951    H332.695z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.141,238.554h8.108l-1.8,8.114h4.511l-1.355,6.311h-4.055    l-2.255,12.175c-0.449,2.255,0,4.511,4.51,3.604l-0.899,6.766c-4.868,3.697-14.615,0.992-13.081-8.115L222.141,238.554z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.296,263.348c0.9-4.959,3.156-17.129-11.361-17.129    c-13.524,0-15.33,13.525-15.33,15.324c-0.444,1.805-0.444,15.33,13.98,15.33c3.604,0,8.657-0.45,10.912-1.35l1.35-6.315    c-1.35,0.456-5.952,0.905-9.557,0.905c-3.154,0-8.564,0-7.665-6.766H258.296z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.92,276.873 167.135,239.903 153.068,239.903     143.147,262.448 141.342,239.903 128.268,239.903 121.052,276.873 129.167,276.873 134.583,250.273 136.838,276.873     144.503,276.873 156.223,250.723 151.262,276.873   ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.385,247.118l-1.35,6.766    c2.255,0,7.664-0.905,10.369-0.905s6.311-0.449,4.961,4.061c-2.256,0-17.137-2.256-19.392,10.819    c-1.257,8.657,9.021,11.813,15.33,7.665l0.905,1.8h7.66l3.16-16.681C194.363,245.584,179.847,245.313,169.385,247.118    L169.385,247.118z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.662,249.823c-2.076-1.264-3.34-1.264-5.952-1.264    c-2.526,0-8.479,2.526-9.292,9.286c-1.264,8.479,4.239,12.268,12.262,9.742l2.169,7.215c-13.704,6.852-26.788-3.79-22.456-20.383    c3.512-12.533,20.108-20.105,28.408-9.736L303.662,249.823z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.168,249.823c-22.096-16.594-30.666,27.05-13.531,27.05    c2.705,0,5.416-1.35,7.216-2.255l0.899,2.255h9.021l7.216-38.775h-8.57L375.168,249.823z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.15,247.118l-1.35,6.766    c2.248,0,7.665-0.905,10.364-0.905c2.712,0,5.866-0.449,4.966,4.061c-2.254,0-17.135-2.256-19.384,10.819    c-0.913,6.31,4.504,9.465,8.564,9.465c4.054,0,5.409-0.9,6.759-1.8l0.9,1.8h7.671l3.154-16.681    C335.223,245.584,320.699,245.313,310.15,247.118L310.15,247.118z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.625,257.488h10.37    C252.166,249.281,242.338,250.907,240.625,257.488L240.625,257.488z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EB2230"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.016,263.348c-1.355,0-4.51-0.899-7.222,0.906    c-2.698,1.799-3.604,4.954-0.444,5.859c2.699,0.899,6.311-0.905,7.209-3.61L182.016,263.348z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EB2230"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.107,254.783c-2.705-3.611-8.564-0.899-10.37,5.859    c-1.349,4.511,1.356,7.666,4.061,7.666C370.479,268.309,373.905,259.023,371.107,254.783L371.107,254.783z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBB230"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.225,263.348c-1.348,0-4.504-0.899-7.215,0.906    c-2.698,1.799-3.604,4.954-0.443,5.859c2.699,0.899,6.76-0.905,7.209-3.61L323.225,263.348z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBB230"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.296,277.323l0.457-3.155l5.409-27.5h7.21l0.899,3.155    c1.355-1.355,3.611-3.155,8.121-3.155l-2.256,8.115c-1.713,0-5.323-0.363-8.028,6.852c-1.534,4.147-2.434,11.184-3.247,15.688    H258.296z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.654,254.063h-0.364h-0.357l-0.356-0.092l-0.364-0.087    h-0.363l-0.358-0.093c-1.626-0.178-2.976-0.271-4.596-0.178c-4.153,0.357-5.952,2.969-2.439,4.953    c2.797,1.627,4.965,1.355,6.851,3.161c4.062,3.784,1.984,11.091-2.526,13.883l-0.807,0.363l-0.9,0.363l-0.991,0.265l-0.899,0.271    c-4.332,0.721-10.191,0.542-14.432-0.899l1.172-6.045c3.426,0.721,9.021,2.255,11.633,0.456c2.977-1.984,0.271-4.332-1.898-5.323    l-1.078-0.358l-1.078-0.449c-8.57-3.883-6.58-14.253,1.528-16.415c3.247-0.721,6.495-0.721,9.834-0.45h0.628    c0.814,0.087,1.535,0.18,2.256,0.358h0.357l0.271,0.092h0.271l0.178,0.092h0.271L214.654,254.063L214.654,254.063z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.c233b1d2.svg";
export { ForwardRef as ReactComponent };